<template>
  <div v-if="formattedCreatedAt" class="flex gap-1 items-center" data-testid="item-created-at">
    <MetadataIcon name="calendar" />
    <span>{{ formattedCreatedAt }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import MetadataIcon from '@/modules/viewer/components/meta_buttons/MetadataIcon.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const { createdAt } = storeToRefs(useViewerItemStore());

const formattedCreatedAt = computed(() => {
  const dateParts = createdAt.value?.match(/^(\d{4})-(\d{2})-(\d{2})(?:T|$)/);
  const date = createdAt.value ? new Date(createdAt.value) : undefined;

  if (!dateParts || !date || Number.isNaN(date.getTime())) {
    return undefined;
  }

  const [year, month, day] = dateParts.slice(1).map(Number);
  const calendarDate = new Date(Date.UTC(year, month - 1, day));

  if (calendarDate.getUTCFullYear() !== year || calendarDate.getUTCMonth() !== month - 1 || calendarDate.getUTCDate() !== day) {
    return undefined;
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
});
</script>
